/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { environment } from './../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { List } from 'immutable';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NbThemeModule } from '@nebular/theme';
import { NbCardModule } from '@nebular/theme';
import { NbLayoutModule } from '@nebular/theme';
import { NbMenuModule } from '@nebular/theme';
import { NbRouteTabsetModule } from '@nebular/theme';
import { NbSidebarModule } from '@nebular/theme';
import { NbTabsetModule } from '@nebular/theme';
import { NbUserModule } from '@nebular/theme';
import { NbAuthModule, NbEmailPassAuthProvider } from './../framework/auth';
import { NbActionsModule } from '@nebular/theme';
import { NbSearchModule } from '@nebular/theme';
import { NbMenuItem } from '@nebular/theme';
import { BaCheckboxComponent } from '@nebular/theme';
import { NbCheckboxModule } from '@nebular/theme';
import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';

import { NbAppComponent } from './app.component';
import { NbLayoutComponent } from './layout-main/layout.component';
import { AppRoutingModule } from './app.routing.module';
import { NbUserTestComponent } from './user-test/user-test.component';
import { NbActionsTestComponent } from './actions-test/actions-test.component';
import { NbBootstrapTestComponent } from './bootstrap-test/bootstrap-test.component';
import { NbFormsTestComponent } from './forms-test/forms-test.component';
import { NbCardTestComponent } from './card-test/card-test.component';
import { AuthGuard } from './../app/auth.guard';
import { UserService, UserGroupService, SupplierService, ZHttpService } from './services';
import { DataService } from './card-test/data.service';
import { IqSelect2Module } from 'ng2-iq-select2';
import { DashboardModule } from './dashboard/dashboard.module';
import { SuppliersBarcodesModule } from './suppliers-barcodes/supplier-barcodes.module';

const NB_TEST_COMPONENTS = [
  NbAppComponent,
  NbCardTestComponent,
  NbLayoutComponent,
  NbUserTestComponent,
  BaCheckboxComponent,
  NbBootstrapTestComponent,
  NbActionsTestComponent,
  NbFormsTestComponent,
];

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    ToasterModule,
    NbThemeModule.forRoot({ name: 'metro' }),
    NbCardModule,
    NbLayoutModule,
    NbMenuModule.forRoot(),
    NbRouteTabsetModule,
    NbSidebarModule.forRoot(),
    NbTabsetModule,
    NbUserModule,
    NbSearchModule,
    IqSelect2Module,
    ReactiveFormsModule,
    NbActionsModule,
    NbCheckboxModule,
    NgbModule.forRoot(),
    NbAuthModule.forRoot({
      providers: {
        email: {
          service: NbEmailPassAuthProvider,
          config: {
            login: {
              endpoint: environment.apiUrl + '/api/auth/login',
            },
            register: {
              endpoint: environment.apiUrl + '/api/auth/register',
            },
            logout: {
              endpoint: environment.apiUrl + '/api/auth/logout',
              redirect: {
                success: '/auth/login',
                failure: '/auth/login',
              },
            },
            requestPass: {
              endpoint: environment.apiUrl + '/api/auth/request-pass',
              redirect: {
                success: '/auth/reset-password',
              },
            },
            resetPass: {
              endpoint: environment.apiUrl + '/api/auth/reset-pass',
              redirect: {
                success: '/auth/login',
              },
            },
          },
        },
      },
    }),
    AppRoutingModule,
    DashboardModule,
    SuppliersBarcodesModule,
  ],
  declarations: [
    ...NB_TEST_COMPONENTS,
  ],
  entryComponents: [
    // NbDynamicToAddComponent,
  ],
  providers: [DataService, ZHttpService, UserService, UserGroupService, SupplierService, AuthGuard],
  bootstrap: [NbAppComponent],
})
export class NbAppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts